export default {
  allFinancialReports: [],
}
